/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon16Light = forwardRef('TagIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.478 3a2.5 2.5 0 0 0-1.973.965L.56 6.465a2.5 2.5 0 0 0 0 3.07l1.945 2.5A2.5 2.5 0 0 0 4.478 13H11.5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3H4.478ZM3.294 4.58A1.5 1.5 0 0 1 4.478 4H11.5A1.5 1.5 0 0 1 13 5.5v5a1.5 1.5 0 0 1-1.5 1.5H4.478a1.5 1.5 0 0 1-1.184-.58L1.35 8.92a1.5 1.5 0 0 1 0-1.84l1.944-2.5Z" })));
});
